import { ColoursObj } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useMemo } from 'react'
import { useFormatValue } from '../../hooks/useFormatValue'
import { CardText } from '../subComponents/cardText'
import { ColouredIcon } from '../subComponents/colouredIcon'
import { DisplayLabel } from '../subComponents/displayLabel'
import { TodoRange } from '../todoCard'
interface ITodoHeaderProps {
    todoName?: string
    dueDate?: string
    colour?: string
    range?: TodoRange
}
export const TodoHeader = ({
    todoName,
    dueDate,
    colour,
    range,
}: ITodoHeaderProps) => {
    const { formatValue } = useFormatValue()

    const label = useMemo(() => {
        return dueDate ? 'Due ' + formatValue(dueDate, 'date') : ''
    }, [dueDate, formatValue])
    return (
        <Stack direction={'row'} gap={'8px'} justifyContent={'space-between'}>
            <Stack direction={'row'} gap={'8px'}>
                <ColouredIcon name={'ToDo'} iconColour={colour} />
                <CardText
                    color={
                        range === 'done'
                            ? ColoursObj.shades.shade2
                            : ColoursObj.font.primary
                    }
                    variant="bodyBold"
                >
                    {todoName}
                </CardText>
            </Stack>
            {range !== 'done' && (
                <DisplayLabel
                    textProps={{
                        flexShrink: 0,
                        whiteSpace: 'nowrap',
                    }}
                    label={label}
                    labelTime={dueDate}
                />
            )}
        </Stack>
    )
}
